import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AdministrationAccessRightActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/AccessRight/AccessRightBrowser")
	}

	render() {
		return (
			<Activity 
				name="AdministrationAccessRight"
				RenderedComponent={this.RenderedComponent}
				context="AdministrationAccessRight"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AdministrationAccessRightActivity)
